<template>
  <div class="cert-result-page">
    <div class="zs-wmain">
      <div class="cert-title">
        <h1>证书查询结果</h1>
        <p>Certificate Query Result</p>
      </div>

      <div class="html zhengshu-result2" v-if="inqsucess">
        <div class="result-status">
          <span class="success-icon"></span>
          <strong>查询成功</strong>
          <p>已找到对应的证书信息</p>
        </div>

        <div class="cert-info-list">
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">姓名</span>
            <strong>{{ cert.name }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">性别</span>
            <strong>{{ cert.sex }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">出生日期</span>
            <strong>{{ cert.birth }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">证件类型</span>
            <strong>{{ cert.cardtype || cert.certtype || "居民身份证" }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">身份证号</span>
            <strong>{{ cert.cardid }}</strong>
          </div>
        
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">学历</span>
            <strong>{{ cert.edu }}</strong>
          </div>
         
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">申报专业</span>
            <strong>{{ cert.certifyname}}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">申报级别</span>
            <strong>{{ cert.certifylevel }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">证书编号</span>
            <strong>{{ cert.certid }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">发证日期</span>
            <strong>{{ cert.certifydate }}</strong>
          </div>
          <div class="cert-info-item">
            <span class="dot"></span>
            <span class="label">工作单位</span>
            <strong>{{ cert.workunit }}</strong>
          </div>
        </div>

        <router-link class="back-query" to="/inqcert">返回查询</router-link>
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNav from "../components/PublicComs/HeadNav";
import FootInfo from "../components/HomeComs/FootInfo.vue";
import global from "@/components/PublicComs/Common.vue";
import { Message} from "element-ui"
import QRCode from "qrcodejs2";
// console.log(window.innerWidth)
// const rate= window.innerWidth/1240;
export default {
  metaInfo: {
      title: '查询结果',
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=no, initial-scale=${1}, maximum-scale=${1}, minimum-scale=${1}`}
      ]
    },
  props: {},
  components: { FootInfo, HeadNav },
  data() {
    return {
      global,
      cert: {},
      result: false,
      restext: "请输入查询条件",
      plates: [],
      webConfigs: {},
      type: "",
      queryType: "人才信息",
      cardid: "",
      certid: "",
      companyname: "",
      socialcreditcode: "",
      id:'',
      inqsucess:false
    };
  },

  created() {
    let code = this.$route.query.code;
    let name = this.$route.query.name;
    
    
  },

  methods: {
    creatQrCode(code, name) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: encodeURI(
          `${global.remoteIp}/certResult?code=${code}&name=${name}`
        ), // 闇€瑕佽浆鎹负浜岀淮鐮佺殑鍐呭
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  },

  computed: {},

  mounted() {
     let code = this.$route.query.code;
    let name = this.$route.query.name;
    this.$axios
      .get(encodeURI(`/api/certificates1/userget?certid=${code}&name=${name}`))
      .then((res) => {
        if (res.data.data.length > 0) {
          this.cert = res.data.data[0];
          this.cert.birth = getBirthDateFromIdCard(this.cert.cardid);
          this.inqsucess = true;
          this.$nextTick(() => {
      this.creatQrCode(code, name);
    })
          return;
        } else {
          this.$router.replace("/inqcert");
          Message.error("为查询到任何信息，请重新输入信息查询！");
        }
      })
      .catch((err) => {
        this.$router.replace("/inqcert");
        Message.error("为查询到任何信息，请重新输入信息查询！");
      });
      function getBirthDateFromIdCard(idCard) {
          const value = String(idCard || "").trim();
          const match = value.match(/^\d{6}(\d{4})(\d{2})(\d{2})\d{3}[\dXx]$/);
          console.log(value, match);
          if (!match) return "";

          const [, year, month, day] = match;
          const date = new Date(`${year}-${month}-${day}`);

          if (
            date.getFullYear() !== Number(year) ||
            date.getMonth() + 1 !== Number(month) ||
            date.getDate() !== Number(day)
          ) {
            return "";
          }

          return `${year}年${month}月${day}日`;
        }
  },

  watch: {},
};
</script>

<style scoped>
.cert-result-page {
  color: #1d2a3d;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.zs-wmain {
  position: relative;
  box-sizing: border-box;
  padding: 50px 24px 82px;
  overflow: hidden;
  background-image:
    url("/static/img/info-query/back2.png"),
    radial-gradient(circle at 50% 44%, rgba(255, 255, 255, 0.95) 0, rgba(255, 255, 255, 0.92) 36%, rgba(232, 246, 255, 0.86) 74%, rgba(220, 242, 255, 0.94) 100%);
  background-repeat: no-repeat;
  background-position: center top, center;
  background-size: cover, cover;
}

.zs-wmain::after {
  content: "Copyright ©2022 · bjrs.org.cn 北京软数信息技术研究院  京ICP备16059467号-5";
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  width: 100%;
  color: #8994a3;
  font-size: 14px;
  letter-spacing: 1px;
  text-align: center;
}

.cert-title {
  margin-bottom: 50px;
  text-align: center;
}

.cert-title h1 {
  margin: 0;
  color: #155DFC;
  background: linear-gradient(90deg, #155DFC 0%, #0092B8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 44px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 3px;
}

.cert-title p {
  margin: 12px 0 0;
  color: #0062ff;
  font-size: 18px;
  line-height: 1.0;
}

.zhengshu-result2 {
  position: relative;
  width: min(1200px, calc(100vw - 48px));
  min-height: 620px;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 50px 50px 40px;
  border: 2px solid rgba(87, 166, 255, 0.78);
  border-radius: 14px;
  background:
    url("/static/img/info-query/hua.png") center 50% / 520px auto no-repeat,
    rgba(255, 255, 255, 0.82);
  box-shadow: 0 18px 44px rgba(41, 122, 202, 0.12);
}

.result-status {
  text-align: center;
}

.success-icon {
  position: absolute;
  top: -26px;
  left: 50%;
  width: 64px;
  height: 64px;
  transform: translateX(-50%);
  border-radius: 50%;
  background: #09cc7d;
  box-shadow: 0 10px 20px rgba(9, 204, 125, 0.32);
}

.success-icon::before {
  content: "";
  position: absolute;
  left: 19px;
  top: 18px;
  width: 25px;
  height: 14px;
  border-left: 5px solid #fff;
  border-bottom: 5px solid #fff;
  transform: rotate(-45deg);
  border-radius: 2px;
}

.result-status strong {
  display: block;
  margin-top: 2px;
  color: #1f2c3f;
  font-size: 24px;
  line-height: 1.35;
}

.result-status p {
  margin: 8px 0 42px;
  color: #697587;
  font-size: 16px;
}

.cert-info-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 36px;
  row-gap: 20px;
}

.cert-info-item {
  position: relative;
  min-height: 78px;
  box-sizing: border-box;
  padding: 0 0 18px 32px;
  border-bottom: 2px solid rgba(167, 205, 244, 0.46);
}

.cert-info-item:nth-child(10),
.cert-info-item:nth-child(11) {
  grid-column: span 1;
}

.cert-info-item .dot {
  position: absolute;
  top: 3px;
  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #dbeafe;
}

.cert-info-item .dot::after {
  content: "";
  position: absolute;
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1d83ff;
}

.cert-info-item:nth-child(3n + 2) .dot::after {
  background: #0dbce6;
}

.cert-info-item:nth-child(3n) .dot::after {
  background: #16add5;
}

.cert-info-item .label {
  display: block;
  margin-bottom: 10px;
  color: #6f7c8e;
  font-size: 14px;
  line-height: 20px;
}

.cert-info-item strong {
  display: block;
  color: #1d2a3d;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.35;
  word-break: break-all;
}

.back-query {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 240px;
  height: 50px;
  margin: 56px auto 0;
  border-radius: 8px;
  color: #fff !important;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  background: linear-gradient(100deg, #2f82ff 0%, #00b7d2 100%);
  box-shadow: 0 10px 18px rgba(22, 126, 220, 0.24);
}

.qrcode {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
}

@media (max-width: 900px) {
  .zs-wmain {
    padding: 52px 16px 76px;
  }

  .cert-title {
    margin-bottom: 38px;
  }

  .cert-title h1 {
    font-size: 34px;
  }

  .zhengshu-result2 {
    width: 100%;
    min-height: 0;
    padding: 62px 22px 32px;
    background-size: 360px auto, auto;
  }

  .cert-info-list {
    grid-template-columns: 1fr;
    row-gap: 18px;
  }

  .cert-info-item {
    min-height: 68px;
  }

  .cert-info-item strong {
    font-size: 18px;
  }

  .back-query {
    width: 210px;
    margin-top: 34px;
  }
}
</style>
